import { render, staticRenderFns } from "./FormRadio.vue?vue&type=template&id=1969fa2c&"
import script from "./FormRadio.vue?vue&type=script&lang=js&"
export * from "./FormRadio.vue?vue&type=script&lang=js&"
import style0 from "./FormRadio.vue?vue&type=style&index=0&id=1969fa2c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports